import { render, staticRenderFns } from "./shareAlert.vue?vue&type=template&id=b2cd0bee&scoped=true"
import script from "./shareAlert.vue?vue&type=script&lang=js"
export * from "./shareAlert.vue?vue&type=script&lang=js"
import style0 from "./shareAlert.vue?vue&type=style&index=0&id=b2cd0bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cd0bee",
  null
  
)

export default component.exports